module.exports = __webpack_public_path__ + "static/media/a9eaf4d3-6427-42df-9306-3ea1270f7b1a.5bb1c0af.woff2";